import Card from "components/ui-elements/Card";
import DataTable from "components/datatable/DataTable";
import Row from "components/ui-elements/Row";

export const parseBoolean = (value) =>
  value === true || value === "true" || value === "t" || value === 1 || value === "1";

export const hasPermission = (user, permissionCode) => {
  const items = Array.isArray(user?.permissions) ? user.permissions : [];
  return items.some(
    (item) =>
      String(item?.permission_code || "") === String(permissionCode || ""),
  );
};

export const listItems = (resp) => {
  if (Array.isArray(resp?.data)) return resp.data;
  return [];
};

export const listPagination = (resp) => {
  if (resp?.page) return resp.page;
  return { page: 1, perpage: 20, count: 0, total_page: 0 };
};

export const parseIDList = (value) => {
  if (!value) return [];
  if (Array.isArray(value))
    return value.map((item) => Number(item)).filter((item) => item > 0);
  return String(value)
    .replace(/[{}]/g, "")
    .split(",")
    .map((item) => Number(item.trim()))
    .filter((item) => item > 0);
};

export const parseGroupIDs = parseIDList;

export const boolText = (
  value,
  trueLabel = "Aktif",
  falseLabel = "Nonaktif",
) => (parseBoolean(value) ? trueLabel : falseLabel);

export const showEmpty = (value, empty = "-") => {
  if (value === 0) return "0";
  if (value === false) return "false";
  return value ? String(value) : empty;
};

export const SectionAlert = ({ message, type = "danger" }) => {
  if (!message) return null;
  return <div className={`alert alert-${type}`}>{message}</div>;
};

export const SectionCard = ({ title, children, className = "" }) => (
  <Card title={title} className={className}>
    {children}
  </Card>
);

export const SystemTableCard = ({
  title,
  description,
  data,
  dlist,
  coltype,
  paging,
  loading,
  error,
  children,
}) => (
  <Card title={title}>
    {description ? <p className="text-muted">{description}</p> : null}
    {loading ? <div>Memuat data...</div> : null}
    {error ? <SectionAlert message={error} /> : null}
    {!loading && !error && (!data || data.length < 1) ? (
      <div>Tidak ada data.</div>
    ) : null}
    {!loading && !error && data && data.length > 0 ? (
      <Row>
        <DataTable
          data={data}
          dlist={dlist}
          paging={paging}
          coltype={coltype}
        />
      </Row>
    ) : null}
    {children}
  </Card>
);
